/**
 * PDP accordion: scroll-on-open + fix apertura.
 *
 * custom-accessibility.js fa replaceWith() sul trigger e può distruggere
 * i listener del tema. Qui gestiamo i click su .c-wide-accordions in capture,
 * così funzionano sempre (indipendentemente dalla race).
 */
(function () {
  var SCROLL_OFFSET = 16;
  var DURATION = 600;
  var OPEN_DELAY = 400;
  var HEIGHT_SETTLE = 500;
  var MAX_RETRIES = 10;
  var RETRY_INTERVAL = 300;

  function initAccordionScroll(attempt) {
    var container = document.querySelector('.c-pdp__main');
    if (!container) {
      if (attempt < MAX_RETRIES) {
        setTimeout(function () { initAccordionScroll(attempt + 1); }, RETRY_INTERVAL);
      }
      return;
    }

    var isScrolling = false;

    function getScrollTarget() {
      if (container.scrollHeight > container.clientHeight) {
        var style = getComputedStyle(container);
        if (style.overflowY === 'auto' || style.overflowY === 'scroll') {
          return container;
        }
      }
      return document.documentElement;
    }

    function smoothScrollTo(targetPosition) {
      if (isScrolling) return;

      var scrollEl = getScrollTarget();
      var startScroll = scrollEl.scrollTop;
      var distance = targetPosition - startScroll;

      if (Math.abs(distance) < 3) return;

      isScrolling = true;
      var startTime = performance.now();

      function easeOutCubic(t) {
        return 1 - Math.pow(1 - t, 3);
      }

      function animate(now) {
        var elapsed = now - startTime;
        var progress = Math.min(elapsed / DURATION, 1);
        scrollEl.scrollTop = startScroll + distance * easeOutCubic(progress);

        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          isScrolling = false;
        }
      }

      requestAnimationFrame(animate);
    }

    function scrollToElement(el) {
      if (!el) return;

      var scrollEl = getScrollTarget();
      var targetPosition;

      if (scrollEl === container) {
        var triggerRect = el.getBoundingClientRect();
        var containerRect = container.getBoundingClientRect();
        targetPosition = container.scrollTop + (triggerRect.top - containerRect.top) - SCROLL_OFFSET;
      } else {
        var rect = el.getBoundingClientRect();
        targetPosition = window.pageYOffset + rect.top - SCROLL_OFFSET;
      }

      smoothScrollTo(Math.max(0, targetPosition));
    }

    function onAccordionOpened(accordion) {
      var trigger = accordion.querySelector('.js-accordion-trigger, .c-accordion__title, summary');
      if (trigger) {
        scrollToElement(trigger);
      }
    }

    /* ——— Fix apertura: stessa logica del tema Accordion ——— */
    function openAccordion(accordion, trigger, content, inner) {
      accordion.classList.add('is-accordion-open');
      accordion.classList.add('is-active');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');

      var h = inner ? inner.offsetHeight : 0;
      if (content) {
        content.style.height = h + 'px';
        setTimeout(function () {
          if (accordion.classList.contains('is-accordion-open')) {
            content.style.height = 'initial';
          }
        }, HEIGHT_SETTLE);
      }
    }

    function closeAccordion(accordion, trigger, content) {
      accordion.classList.remove('is-accordion-open');
      accordion.classList.remove('is-active');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (content) content.style.height = '';
    }

    function toggleThemeAccordion(accordion) {
      var trigger = accordion.querySelector('.js-accordion-trigger, .c-accordion__title');
      var content = accordion.querySelector('.js-accordion-content, .c-accordion__content');
      var inner = accordion.querySelector('.js-accordion-inner, .c-accordion__inner');
      var isOpen = accordion.classList.contains('is-accordion-open') ||
        accordion.classList.contains('is-active');

      if (isOpen) {
        closeAccordion(accordion, trigger, content);
      } else {
        openAccordion(accordion, trigger, content, inner);
        // scroll gestito dal MutationObserver su is-accordion-open
      }
    }

    // Capture: prendiamo il click prima del tema / custom-accessibility
    // Scope solo PDP (.c-wide-accordions), non nav/footer.
    var wide = container.querySelector('.c-wide-accordions') || container;
    wide.addEventListener('click', function (e) {
      var trigger = e.target.closest('.js-accordion-trigger, .c-accordion__title');
      if (!trigger || !wide.contains(trigger)) return;

      // Ignora summary nativi (gestiti dal browser)
      if (trigger.tagName === 'SUMMARY') return;

      var accordion = trigger.closest('.js-accordion, .c-accordion');
      if (!accordion || !wide.contains(accordion)) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      toggleThemeAccordion(accordion);
    }, true);

    /* ——— Scroll observer (theme class toggle) ——— */
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        if (mutation.attributeName !== 'class') continue;

        var el = mutation.target;
        var isAccordion = el.classList.contains('js-accordion') || el.classList.contains('c-accordion');
        if (!isAccordion) continue;

        // Lo scroll in apertura è già gestito da toggleThemeAccordion;
        // qui copriamo eventuali aperture da altri script.
        var isOpen = el.classList.contains('is-accordion-open') || el.classList.contains('is-active');
        if (!isOpen) continue;
        if (el._pdpScrollPending) continue;

        el._pdpScrollPending = true;
        (function (target) {
          setTimeout(function () {
            onAccordionOpened(target);
            target._pdpScrollPending = false;
          }, OPEN_DELAY);
        })(el);
      }
    });

    var accordions = container.querySelectorAll('.c-wide-accordions .js-accordion, .c-wide-accordions .c-accordion');
    for (var i = 0; i < accordions.length; i++) {
      observer.observe(accordions[i], { attributes: true, attributeFilter: ['class'] });
    }

    /* ——— Accordion nativi <details> ——— */
    var detailsEls = container.querySelectorAll('details.c-pdp-accordion');
    for (var j = 0; j < detailsEls.length; j++) {
      (function (det) {
        det.addEventListener('toggle', function () {
          if (det.open) {
            setTimeout(function () {
              var summary = det.querySelector('.c-pdp-accordion__title, summary');
              scrollToElement(summary);
            }, OPEN_DELAY);
          }
        });
      })(detailsEls[j]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAccordionScroll(0); });
  } else {
    initAccordionScroll(0);
  }
})();
